import React from 'react';
import { Clickable, Stack, Text, Divider } from '@moda/om';
import ExitIcon from '@moda/icons/exit-16';
import {
  BackInStockNotificationFormFragment,
  BackInStockNotificationFormInventoryFragment
} from '../../generated/types';
import { ModalOverlay } from '../Modal';
import { BackInStockNotificationForm } from './BackInStockNotificationForm';
import './BackInStockNotificationModal.scss';

type Props = {
  show: boolean;
  activeVariantId: string;
  variant: BackInStockNotificationFormFragment;
  size?: BackInStockNotificationFormInventoryFragment;
  onClose: () => void;
  place?: string;
};

export const BackInStockNotificationModal: React.FC<Props> = ({
  show,
  activeVariantId,
  variant,
  size,
  onClose,
  place
}) => (
  <ModalOverlay show={show} onClose={onClose}>
    <div className="BackInStockNotificationModal">
      <Clickable
        className="BackInStockNotificationModal__close"
        aria-label="Close"
        onClick={onClose}
      >
        <ExitIcon />
      </Clickable>
      <Stack space={4}>
        <Text className="BackInStockNotificationModal__title" treatment="h3" family="serif">
          Notify Me
        </Text>
        <Stack space={4}>
          <Divider />
          <BackInStockNotificationForm
            activeVariantId={activeVariantId}
            variant={variant}
            size={size}
            onClose={onClose}
            place={place}
          />
        </Stack>
      </Stack>
    </div>
  </ModalOverlay>
);
